import React from 'react';
import SearchCustomerAndTable from './SearchCustomerAndTable';
import SearchBankAndTableReportUnMatch from './SearchBankAndTableReportUnMatch';
import { useTranslation } from 'react-i18next';

function ReportUnmatchMain() {
  const  { t } = useTranslation();
  return (
    <div>
      <div className="font-bold  text-lg mt-2 mb-4">{t('app.reportUnmatch')}</div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
        <div className="w-full">
          {' '}
          <SearchCustomerAndTable 
          t={t}/>{' '}
        </div>
        <div>
          <SearchBankAndTableReportUnMatch   t={t} />{' '}
        </div>
      </div>
    </div>
  );
}

export default ReportUnmatchMain;
